import {
  GET_EXECUTIVE_LIST_REQUEST,
  GET_EXECUTIVE_LIST_SUCCESS,
  GET_EXECUTIVE_LIST_FAILURE,
  POST_SEND_EXECUTIVE_LIST_REQUEST,
  POST_SEND_EXECUTIVE_LIST_SUCCESS,
  POST_SEND_EXECUTIVE_LIST_FAILURE,
  GET_EXPORTED_LIST_REQUEST,
  GET_EXPORTED_LIST_SUCCESS,
  GET_EXPORTED_LIST_FAILURE,
  GET_EXECUTIVE_LIST_BY_ID_REQUEST,
  GET_EXECUTIVE_LIST_BY_ID_SUCCESS,
  GET_EXECUTIVE_LIST_BY_ID_FAILURE,
  GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_REQUEST,
  GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_SUCCESS,
  GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_FAILURE,
  POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_REQUEST,
  POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_SUCCESS,
  POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_AI_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_AI_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_AI_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_RIVAL_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_RIVAL_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_RIVAL_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_INCLUDE_PARENT_AND_CHILD_CORPORATION_KEYMAN_LIST_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_FAILURE,
  GET_EXECUTIVE_LIST_FILTERS_REQUEST,
  GET_EXECUTIVE_LIST_FILTERS_SUCCESS,
  GET_EXECUTIVE_LIST_FILTERS_FAILURE,
  POST_EXECUTIVE_LIST_FILTERS_REQUEST,
  POST_EXECUTIVE_LIST_FILTERS_SUCCESS,
  POST_EXECUTIVE_LIST_FILTERS_FAILURE,
  PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST,
  PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS,
  PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE,
  DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST,
  DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS,
  DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE,
  GET_EXECUTIVE_LIST_UPDATE_REQUEST,
  GET_EXECUTIVE_LIST_UPDATE_SUCCESS,
  GET_EXECUTIVE_LIST_UPDATE_FAILURE,
  POST_EXECUTIVE_LIST_CSV_REQUEST,
  POST_EXECUTIVE_LIST_CSV_SUCCESS,
  POST_EXECUTIVE_LIST_CSV_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_GETTAGS_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_GETTAGS_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_GETTAGS_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_FAILURE,
  POST_EXECUTIVE_LIST_SALESFORCE_SYNC_REQUEST,
  POST_EXECUTIVE_LIST_SALESFORCE_SYNC_SUCCESS,
  POST_EXECUTIVE_LIST_SALESFORCE_SYNC_FAILURE,
  SET_SHOW_EXEC_LIST_INFO_BOX,
  SET_SHOW_EXEC_LIST_BANNER,
  CLEAR_EXECUTIVE_LIST,
  CLEAR_ATTACK_LIST_STATE,
  POST_ATTACK_LIST_ANALYZE_URL_REQUEST,
  POST_ATTACK_LIST_ANALYZE_URL_SUCCESS,
  POST_ATTACK_LIST_ANALYZE_URL_FAILURE,
  POST_ATTACK_LIST_EXECUTE_TAGGING_REQUEST,
  POST_ATTACK_LIST_EXECUTE_TAGGING_SUCCESS,
  POST_ATTACK_LIST_EXECUTE_TAGGING_FAILURE,
} from '../../constants/ActionTypes'

import { getUser } from './AccountSetting';
import { ExecutiveListApi } from '../api/ExecutiveListApi';
import { ExecutiveListFiltersApi } from '../api/ExecutiveListFiltersApi';

import * as moment from 'moment';

/*** /executive_list GET ***/
const getExecutiveListRequest = (overwrite, data) => ({
  type: GET_EXECUTIVE_LIST_REQUEST,
  payload: {
    overwrite: overwrite,
    page: data["page"],
  }
});

const getExecutiveListSuccess = (list, pageInfo, overwrite) => ({
  type: GET_EXECUTIVE_LIST_SUCCESS,
  payload: {
    list: list,
    pageInfo: pageInfo,
    overwrite: overwrite,
    corporationCount: pageInfo ? pageInfo.corporation_count : undefined,
  }
});

const getExecutiveListFailure = (error) => ({
  type: GET_EXECUTIVE_LIST_FAILURE,
  payload: {
    error: error
  }
});

export const getExecutiveList = (data, overwrite = false) => {
  return (dispatch) => {
    dispatch(getExecutiveListRequest(overwrite, data));

    ExecutiveListApi.getExecutiveList(data, dispatch)
      .then((response) => {
        dispatch(getExecutiveListSuccess(
          response.data.data,
          response.data.meta,
          overwrite,
        ));
      })
      .catch((error) => {
        dispatch(getExecutiveListFailure(error.response.data));
      });
  };
}

/*** GET /executive_list/{id} ***/
const getExecutiveListByIdRequest = (id) => ({
  type: GET_EXECUTIVE_LIST_BY_ID_REQUEST,
  payload: {
    id: id,
  }
});

const getExecutiveListByIdSuccess = (id, item) => ({
  type: GET_EXECUTIVE_LIST_BY_ID_SUCCESS,
  payload: {
    id: id,
    item: item,
  }
});

const getExecutiveListByIdFailure = (id, error) => ({
  type: GET_EXECUTIVE_LIST_BY_ID_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function getExecutiveListById(id, data = null) {
  return async (dispatch) => {
    dispatch(getExecutiveListByIdRequest(id));

    ExecutiveListApi.getExecutiveListById(id, data, dispatch)
      .then((response) => {
        dispatch(getExecutiveListByIdSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(getExecutiveListByIdFailure(error.response));
      });
  };
}

/*** GET /executive_list/executive_persons/{executive_person_id} ***/
const getExecutiveListByExecutivePersonIdRequest = (id) => ({
  type: GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_REQUEST,
  payload: {
    id: id,
  }
});

const getExecutiveListByExecutivePersonIdSuccess = (id, item) => ({
  type: GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_SUCCESS,
  payload: {
    id: id,
    item: item,
  }
});

const getExecutiveListByExecutivePersonIdFailure = (id, error) => ({
  type: GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function getExecutiveListByExecutivePersonId(id, data = null) {
  return async (dispatch) => {
    dispatch(getExecutiveListByExecutivePersonIdRequest(id));

    ExecutiveListApi.getExecutiveListByExecutivePersonId(id, data, dispatch)
      .then((response) => {
        dispatch(getExecutiveListByExecutivePersonIdSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(getExecutiveListByExecutivePersonIdFailure(id, error.response));
      });
  };
}

/*** POST /executive_list/search/ai ***/
const postExecutiveListSearchAiRequest = () => ({
  type: POST_EXECUTIVE_LIST_SEARCH_AI_REQUEST,
});

const postExecutiveListSearchAiSuccess = (response) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_AI_SUCCESS,
  payload: {
    response: response
  }
});

const postExecutiveListSearchAiFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_AI_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListSearchAi(prompt, includeWebDiscovery = false) {
  return async (dispatch) => {
    dispatch(postExecutiveListSearchAiRequest());

    // include_web_discovery は true のときだけ付与する（未指定なら従来どおりDB内レコメンドのみ）
    const requestData = includeWebDiscovery ? { prompt, include_web_discovery: true } : { prompt };

    return ExecutiveListApi.postExecutiveListSearchAi(requestData, dispatch)
      .then((response) => {
        const data = response && response.data ? response.data : {};
        // そのままの構造化データをリデューサに渡す
        dispatch(postExecutiveListSearchAiSuccess(data));
        return response;
      })
      .catch((error) => {
        const errorData = error.response && error.response.data ? error.response.data : error;
        dispatch(postExecutiveListSearchAiFailure(errorData));
        throw error;
      });
  };
}

/*** POST /executive_list/build_conditions/ai ***/
// 自然文から検索条件(conditions)を生成するAI API。
// レスポンス(has_conditions/conditions/summary/unmapped/message)はコンポーネント側で
// 分岐処理するため、レスポンスをそのまま返す。エラー(400/500)はApiClientが共通処理する。
export function postExecutiveListBuildConditionsAi(prompt) {
  return async (dispatch) => {
    return ExecutiveListApi.postExecutiveListBuildConditionsAi({ prompt }, dispatch)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  };
}

/*** GET /executive_list/web_candidate/keymen ***/
// Web発見候補(取り込み中)のキーマンをcorporate_numberで取得する。
// ポーリング用途のためレスポンスをそのまま返し、成否・ready判定は呼び出し側で行う。
export function getWebCandidateKeymen(corporateNumber) {
  return async (dispatch) => {
    return ExecutiveListApi.getWebCandidateKeymen({ corporate_number: corporateNumber }, dispatch)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  };
}

/*** GET /executive_list/ai/web_result ***/
// AIレコメンドのWeb補完結果を web_job_token で取得する。
// ポーリング用途のためレスポンスをそのまま返し、ready/failed 判定は呼び出し側で行う。
export function getAiWebResult(token) {
  return async (dispatch) => {
    return ExecutiveListApi.getAiWebResult({ token }, dispatch)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  };
}

/*** POST /executive_list/search/rival ***/
const postExecutiveListSearchRequest = (overwrite, data) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_REQUEST,
  payload: {
    overwrite: overwrite,
    page: data["page"],
  }
});

const postExecutiveListSearchSuccess = (list, pageInfo, overwrite) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_SUCCESS,
  payload: {
    list: list,
    pageInfo: pageInfo,
    overwrite: overwrite,
    corporationCount: pageInfo ? pageInfo.corporation_count : undefined,
  }
});

const postExecutiveListSearchFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListSearch(data, overwrite = false) {
  return async (dispatch) => {
    dispatch(postExecutiveListSearchRequest(overwrite, data));

    ExecutiveListApi.postExecutiveListSearch(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListSearchSuccess(
          response.data.data,
          response.data.meta,
          overwrite,
        ));
      })
      .catch((error) => {
        dispatch(postExecutiveListSearchFailure(error.response.data));
      });
  };
}

/*** POST /executive_list/no_match_corporation_csv ***/
const postNoMatchCorporationCsvRequest = () => ({
  type: POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_REQUEST,
});

const postNoMatchCorporationCsvSuccess = (data) => ({
  type: POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_SUCCESS,
  payload: {
    data: data
  }
});

const postNoMatchCorporationCsvFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_FAILURE,
  payload: {
    error: error
  }
});

export function postNoMatchCorporationCsv(data) {
  return async (dispatch) => {
    dispatch(postNoMatchCorporationCsvRequest(data));

    ExecutiveListApi.postNoMatchCorporationCsv(data, dispatch)
      .then((response) => {
        dispatch(postNoMatchCorporationCsvSuccess(
          response.data.data
        ));

        // \uFEFFは通称BOM テキストの始まりをプログラムに伝えることを目的とする目印
        let blob = new Blob(["\uFEFF" + response.data], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `keyman-letter-no-match-corporation${moment().format('YYYYMMDD')}.csv`);
        document.body.appendChild(link);

        link.click();
      })
      .catch((error) => {
        dispatch(postNoMatchCorporationCsvFailure(error.response.data));
      });
  };
}

/*** POST /executive_list/copy_log ***/
// コピペ検知ログをバックエンドに記録する。記録のみが目的のため、
// 成否でReduxのstateは更新せず、失敗してもユーザー操作を妨げない。
export function postExecutiveListCopyLog(data) {
  return (dispatch) => {
    return ExecutiveListApi.postExecutiveListCopyLog(data, dispatch)
      .catch(() => {
        // ログ送信に失敗しても画面操作には影響させない
      });
  };
}

/*** POST /executive_list/search ***/
const postExecutiveListSearchRivalRequest = (id) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_RIVAL_REQUEST,
  payload: {
    id: id
  }
});

const postExecutiveListSearchRivalSuccess = (id, list, pageInfo) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_RIVAL_SUCCESS,
  payload: {
    id: id,
    list: list,
    pageInfo: pageInfo,
  }
});

const postExecutiveListSearchRivalFailure = (id, error) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_RIVAL_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function postExecutiveListSearchRival(id, data) {
  return async (dispatch) => {
    dispatch(postExecutiveListSearchRivalRequest(id));

    ExecutiveListApi.postExecutiveListSearch(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListSearchRivalSuccess(id, response.data.data, response.data.meta));
      })
      .catch((error) => {
        dispatch(postExecutiveListSearchRivalFailure(id, error.response));
      });
  };
}

/*** POST /executive_list/search ***/
const postExecutiveListSearchChildCorporationKeymanListRequest = (id) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_REQUEST,
  payload: {
    id: id
  }
});

const postExecutiveListSearchChildCorporationKeymanListSuccess = (id, list, pageInfo) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_SUCCESS,
  payload: {
    id: id,
    list: list,
    pageInfo: pageInfo,
  }
});

const postExecutiveListSearchChildCorporationKeymanListFailure = (id, error) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function postExecutiveListSearchChildCorporationKeymanList(id, data) {
  return async (dispatch) => {
    dispatch(postExecutiveListSearchChildCorporationKeymanListRequest(id));

    ExecutiveListApi.postExecutiveListSearch(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListSearchChildCorporationKeymanListSuccess(id, response.data.data, response.data.meta));
      })
      .catch((error) => {
        dispatch(postExecutiveListSearchChildCorporationKeymanListFailure(id, error.response));
      });
  };
}

/*** POST /executive_list/search ***/
const postExecutiveListSearchParentCorporationKeymanListRequest = (id) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_REQUEST,
  payload: {
    id: id
  }
});

const postExecutiveListSearchParentCorporationKeymanListSuccess = (id, list, pageInfo) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_SUCCESS,
  payload: {
    id: id,
    list: list,
    pageInfo: pageInfo,
  }
});

const postExecutiveListSearchParentCorporationKeymanListFailure = (id, error) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function postExecutiveListSearchParentCorporationKeymanList(id, data) {
  return async (dispatch) => {
    dispatch(postExecutiveListSearchParentCorporationKeymanListRequest(id));

    ExecutiveListApi.postExecutiveListSearch(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListSearchParentCorporationKeymanListSuccess(id, response.data.data, response.data.meta));
      })
      .catch((error) => {
        dispatch(postExecutiveListSearchParentCorporationKeymanListFailure(id, error.response));
      });
  };
}

/*** POST /executive_list/search ***/
const postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanListRequest = (id) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_INCLUDE_PARENT_AND_CHILD_CORPORATION_KEYMAN_LIST_REQUEST,
  payload: {
    id: id
  }
});

const postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanListSuccess = (id, list, pageInfo) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_SUCCESS,
  payload: {
    id: id,
    list: list,
    pageInfo: pageInfo,
  }
});

const postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanListFailure = (id, error) => ({
  type: POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList(id, data) {
  return async (dispatch) => {
    dispatch(postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanListRequest(id));

    ExecutiveListApi.postExecutiveListSearch(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanListSuccess(id, response.data.data, response.data.meta));
      })
      .catch((error) => {
        dispatch(postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanListFailure(id, error.response));
      });
  };
}

/*** POST /executive_list/send_history/ ***/
const postSendExecutiveListRequest = () => ({
  type: POST_SEND_EXECUTIVE_LIST_REQUEST,
});

const postSendExecutiveListSuccess = (hasLetterOrderHistoryNames, duplicateNames, selectExecutivePerson) => ({
  type: POST_SEND_EXECUTIVE_LIST_SUCCESS,
  payload: {
    hasLetterOrderHistoryNames: hasLetterOrderHistoryNames,
    duplicateNames: duplicateNames,
    selectExecutivePerson: selectExecutivePerson,
  },
});

const postSendExecutiveListFailure = (error) => ({
  type: POST_SEND_EXECUTIVE_LIST_FAILURE,
  payload: {
    error: error,
  }
});

export function postSendExecutiveList(data) {
  return async (dispatch) => {
    dispatch(postSendExecutiveListRequest());

    ExecutiveListApi.postSendExecutiveList(data, dispatch)
      .then((response) => {
        dispatch(postSendExecutiveListSuccess(
          response.data.has_letter_order_history_names,
          response.data.duplicate_names,
          response.data.select_executive_person
        ));
      })
      .catch((error) => {
        dispatch(postSendExecutiveListFailure(error.response));
      });
  };
}

/*** /executive_list_filters GET ***/
const getExecutiveListFiltersRequest = () => ({
  type: GET_EXECUTIVE_LIST_FILTERS_REQUEST,
});

const getExecutiveListFiltersSuccess = (filters) => ({
  type: GET_EXECUTIVE_LIST_FILTERS_SUCCESS,
  payload: {
    filters: filters
  }
});

const getExecutiveListFiltersFailure = (error) => ({
  type: GET_EXECUTIVE_LIST_FILTERS_FAILURE,
  payload: {
    error: error
  }
});

export const getExecutiveListFilters = () => {
  return (dispatch) => {
    dispatch(getExecutiveListFiltersRequest());

    ExecutiveListFiltersApi.getExecutiveListFilters(null, dispatch)
      .then((response) => {
        dispatch(getExecutiveListFiltersSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getExecutiveListFiltersFailure(error.response.data));
      });
  };
}

/*** /executive_list_filters POST ***/
const postExecutiveListFiltersRequest = () => ({
  type: POST_EXECUTIVE_LIST_FILTERS_REQUEST,
});

const postExecutiveListFiltersSuccess = (filter) => ({
  type: POST_EXECUTIVE_LIST_FILTERS_SUCCESS,
  payload: {
    filter: filter
  }
});

const postExecutiveListFiltersFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_FILTERS_FAILURE,
  payload: {
    error: error
  }
});

export const postExecutiveListFilters = (data) => {
  return (dispatch) => {
    dispatch(postExecutiveListFiltersRequest());

    ExecutiveListFiltersApi.postExecutiveListFilters(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListFiltersSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postExecutiveListFiltersFailure(error.response.data));
      });
  };
}

/*** /executive_list_filters PATCH ***/
const patchExecutiveListFiltersByIdRequest = (id) => ({
  type: PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST,
  payload: {
    id: id,
  }
});

const patchExecutiveListFiltersByIdSuccess = (id, filter) => ({
  type: PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS,
  payload: {
    id: id,
    filter: filter,
  }
});

const patchExecutiveListFiltersByIdFailure = (error) => ({
  type: PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export const patchExecutiveListFiltersById = (id, data) => {
  return (dispatch) => {
    dispatch(patchExecutiveListFiltersByIdRequest(id));

    ExecutiveListFiltersApi.patchExecutiveListFiltersById(id, data, dispatch)
      .then((response) => {
        dispatch(patchExecutiveListFiltersByIdSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(patchExecutiveListFiltersByIdFailure(error.response.data));
      });
  };
}

/*** /executive_list_filters DELETE ***/
const deleteExecutiveListFiltersByIdRequest = (id) => ({
  type: DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST,
  payload: {
    id: id
  }
});

const deleteExecutiveListFiltersByIdSuccess = (id) => ({
  type: DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS,
  payload: {
    id: id
  }
});

const deleteExecutiveListFiltersByIdFailure = (error) => ({
  type: DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export const deleteExecutiveListFiltersById = (id) => {
  return (dispatch) => {
    dispatch(deleteExecutiveListFiltersByIdRequest());

    ExecutiveListFiltersApi.deleteExecutiveListFiltersById(id, dispatch)
      .then(() => {
        dispatch(deleteExecutiveListFiltersByIdSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteExecutiveListFiltersByIdFailure(error.response.data));
      });
  };
}

export const clearExecutiveList = () => ({
  type: CLEAR_EXECUTIVE_LIST,
});

export const setShowInfoBox = (value) => ({
  type: SET_SHOW_EXEC_LIST_INFO_BOX,
  payload: {
    showInfoBox: value,
  }
});

export const setShowBanner = (value) => ({
  type: SET_SHOW_EXEC_LIST_BANNER,
  payload: {
    setShowBanner: value,
  }
});

/*** POST /executive_list/csv ***/
const postExecutiveListCsvRequest = () => ({
  type: POST_EXECUTIVE_LIST_CSV_REQUEST,
});

const postExecutiveListCsvSuccess = (data) => ({
  type: POST_EXECUTIVE_LIST_CSV_SUCCESS,
  payload: {
    data: data,
  }
});

const postExecutiveListCsvFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_CSV_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListCsv(data) {
  return async (dispatch) => {
    dispatch(postExecutiveListCsvRequest());

    ExecutiveListApi.postExecutiveListCsv(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListCsvSuccess(response.data));
        // userの情報にエクスポートした件数が付与されているので、再度userの情報を取得する
        dispatch(getUser());

        let blob = new Blob(["\uFEFF" + response.data], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `keyman-database-list${moment().format('YYYYMMDD')}.csv`);
        document.body.appendChild(link);

        link.click();
      })
      .catch((error) => {
        dispatch(postExecutiveListCsvFailure(error.response));
      });
  };
}


/*** POST /executive_list/getExportedList ***/
const getExportedListRequest = () => ({
  type: GET_EXPORTED_LIST_REQUEST,
});

const getExportedListSuccess = (data) => ({
  type: GET_EXPORTED_LIST_SUCCESS,
  payload: {
    list: data,
  }
});

const getExportedListFailure = (error) => ({
  type: GET_EXPORTED_LIST_FAILURE,
  payload: {
    error: error
  }
});

export function getExportedList(data) {
  return async (dispatch) => {
    dispatch(getExportedListRequest());

    ExecutiveListApi.getExportedList(data, dispatch)
      .then((response) => {
        dispatch(getExportedListSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getExportedListFailure(error.response));
      });
  };
}

/*** GET /executive_list ***/
const getExecutiveListUpdateRequest = () => ({
  type: GET_EXECUTIVE_LIST_UPDATE_REQUEST,
});

const getExecutiveListUpdateSuccess = (addedKeyman, addedKeymanTotalCount, delKeyman, delKeymanTotalCount, existsDepartmentTelKeyman, existsDepartmentTelKeymanTotalCount, recommendKeyman, recommendKeymanTotalCount) => ({
  type: GET_EXECUTIVE_LIST_UPDATE_SUCCESS,
  payload: {
    addedKeyman: addedKeyman,
    addedKeymanTotalCount: addedKeymanTotalCount,
    delKeyman: delKeyman,
    delKeymanTotalCount: delKeymanTotalCount,
    existsDepartmentTelKeyman: existsDepartmentTelKeyman,
    existsDepartmentTelKeymanTotalCount: existsDepartmentTelKeymanTotalCount,
    recommendKeyman: recommendKeyman,
    recommendKeymanTotalCount: recommendKeymanTotalCount,
  }
});

const getExecutiveListUpdateFailure = (errors) => ({
  type: GET_EXECUTIVE_LIST_UPDATE_FAILURE,
  payload: {
    error: errors
  }
});

export function getExecutiveListUpdate() {
  let data = {
    'page': 1,
    'paging': 1,
    'per_page': 5,
  }

  return async (dispatch) => {
    dispatch(getExecutiveListUpdateRequest());

    Promise.all([
      ExecutiveListApi.postExecutiveListSearch({
        ...data,
        'add_keyman_filter': 'true',
      }),
      ExecutiveListApi.postExecutiveListSearch({
        ...data,
        'del_keyman_filter': 'true',
      }),
      ExecutiveListApi.postExecutiveListSearch({
        ...data,
        'exists_department_tel_keyman_filter': 'true',
      }),
      ExecutiveListApi.postExecutiveListSearch({
        ...data,
        'recommend_keyman_filter': 'true',
      }),
    ])
      .then(values => {
        const promiseFirstIndex = 0;
        const promiseSecondIndex = 1;
        const promiseThirdIndex = 2;
        const promiseFourthIndex = 3;
        let addedKeymanData = values[promiseFirstIndex].data,
              delKeymanData = values[promiseSecondIndex].data,
              existsDepartmentTelKeymanData = values[promiseThirdIndex].data,
              recommendKeymanData = values[promiseFourthIndex].data;

        dispatch(getExecutiveListUpdateSuccess(
          addedKeymanData.data,
          addedKeymanData.meta.total,
          delKeymanData.data,
          delKeymanData.meta.total,
          existsDepartmentTelKeymanData.data,
          existsDepartmentTelKeymanData.meta.total,
          recommendKeymanData.data,
          recommendKeymanData.meta.total,
        ));
      })
      .catch(errors => {
        dispatch(getExecutiveListUpdateFailure(errors));
      })
  };
}

/*** POST /executive_list/tags/gettags ***/
const postExecutiveListTagsGettagsRequest = (isAllTags, overwrite) => ({
  type: POST_EXECUTIVE_LIST_TAGS_GETTAGS_REQUEST,
  payload: {
    isAllTags: isAllTags,
    overwrite: overwrite,
  }
});

const postExecutiveListTagsGettagsSuccess = (tags, isAllTags) => ({
  type: POST_EXECUTIVE_LIST_TAGS_GETTAGS_SUCCESS,
  payload: {
    tags: tags,
    isAllTags: isAllTags,
  }
});

const postExecutiveListTagsGettagsFailure = (error, isAllTags) => ({
  type: POST_EXECUTIVE_LIST_TAGS_GETTAGS_FAILURE,
  payload: {
    error: error,
    isAllTags: isAllTags
  }
});

export function postExecutiveListGetTags(data, isAllTags = true, overwrite = true) {
  return async (dispatch) => {
    dispatch(postExecutiveListTagsGettagsRequest(isAllTags, overwrite));

    ExecutiveListApi.postExecutiveListGetTags(data, dispatch)
      .then((response) => {
        dispatch(postExecutiveListTagsGettagsSuccess(response.data.data, isAllTags));
      })
      .catch((error) => {
        dispatch(postExecutiveListTagsGettagsFailure(error.response, isAllTags));
      });
  };
}

/*** POST /executive_list/tags/deletemulti ***/
const postExecutiveListTagsDeletemultiRequest = () => ({
  type: POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_REQUEST,
});

const postExecutiveListTagsDeletemultiSuccess = () => ({
  type: POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_SUCCESS,
});

const postExecutiveListTagsDeletemultiFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListDeleteTags(data) {
  return async (dispatch) => {
    dispatch(postExecutiveListTagsDeletemultiRequest());

    ExecutiveListApi.postExecutiveListDeleteTags(data, dispatch)
      .then(() => {
        dispatch(postExecutiveListTagsDeletemultiSuccess());
      })
      .catch((error) => {
        dispatch(postExecutiveListTagsDeletemultiFailure(error.response));
      });
  };
}

/*** POST /executive_list/tags/updatetagnamemulti ***/
const postExecutiveListTagsUpdatetagnamemultiRequest = () => ({
  type: POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_REQUEST,
});

const postExecutiveListTagsUpdatetagnamemultiSuccess = () => ({
  type: POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
});

const postExecutiveListTagsUpdatetagnamemultiFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListUpdateTagName(data) {
  return async (dispatch) => {
    dispatch(postExecutiveListTagsUpdatetagnamemultiRequest());

    ExecutiveListApi.postExecutiveListUpdateTagName(data, dispatch)
      .then(() => {
        dispatch(postExecutiveListTagsUpdatetagnamemultiSuccess());
      })
      .catch((error) => {
        dispatch(postExecutiveListTagsUpdatetagnamemultiFailure(error.response));
      });
  };
}

/*** POST /executive_list/tags/updatemulti ***/
const postExecutiveListTagsUpdatemultiRequest = () => ({
  type: POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_REQUEST,
});

const postExecutiveListTagsUpdatemultiSuccess = (tags) => ({
  type: POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_SUCCESS,
  payload: {
    tags: tags,
  }
});

const postExecutiveListTagsUpdatemultiFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListUpdateTag(data) {
  return async (dispatch) => {
    dispatch(postExecutiveListTagsUpdatemultiRequest());

    ExecutiveListApi.postExecutiveListUpdateTag(data, dispatch)
      .then(() => {
        dispatch(postExecutiveListTagsUpdatemultiSuccess(data.tags));
      })
      .catch((error) => {
        dispatch(postExecutiveListTagsUpdatemultiFailure(error.response));
      });
  };
}

/*** POST /executive_list/salesforce/sync ***/
const postExecutiveListSalesforceSyncRequest = () => ({
  type: POST_EXECUTIVE_LIST_SALESFORCE_SYNC_REQUEST,
});

const postExecutiveListSalesforceSyncSuccess = () => ({
  type: POST_EXECUTIVE_LIST_SALESFORCE_SYNC_SUCCESS,
});

const postExecutiveListSalesforceSyncFailure = (error) => ({
  type: POST_EXECUTIVE_LIST_SALESFORCE_SYNC_FAILURE,
  payload: {
    error: error
  }
});

export function postExecutiveListSalesforceSync(data) {
  return async (dispatch) => {
    dispatch(postExecutiveListSalesforceSyncRequest());

    ExecutiveListApi.postExecutiveListSalesforceSync(data, dispatch)
      .then(() => {
        dispatch(postExecutiveListSalesforceSyncSuccess());
      })
      .catch((error) => {
        dispatch(postExecutiveListSalesforceSyncFailure(error.response));
      });
  };
}

export function clearAttackListState() {
  return {
    type: CLEAR_ATTACK_LIST_STATE,
  };
}

/*** POST /executive_list/analyze_url (2段階API Step 1) ***/
const postAttackListAnalyzeUrlRequest = () => ({
  type: POST_ATTACK_LIST_ANALYZE_URL_REQUEST,
});

const postAttackListAnalyzeUrlSuccess = (data) => ({
  type: POST_ATTACK_LIST_ANALYZE_URL_SUCCESS,
  payload: {
    analysisId: data.analysis_id,
    extractedConditions: data.extracted_conditions,
    summary: data.summary,
  }
});

const postAttackListAnalyzeUrlFailure = (error) => ({
  type: POST_ATTACK_LIST_ANALYZE_URL_FAILURE,
  payload: {
    error: error
  }
});

export function postAttackListAnalyzeUrl(data) {
  return async (dispatch) => {
    dispatch(postAttackListAnalyzeUrlRequest());

    ExecutiveListApi.postAttackListAnalyzeUrl(data, dispatch)
      .then((response) => {
        dispatch(postAttackListAnalyzeUrlSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postAttackListAnalyzeUrlFailure(error.response ? error.response.data : error));
      });
  };
}

/*** POST /executive_list/execute_tagging (2段階API Step 2) ***/
const postAttackListExecuteTaggingRequest = () => ({
  type: POST_ATTACK_LIST_EXECUTE_TAGGING_REQUEST,
});

const postAttackListExecuteTaggingSuccess = (data) => ({
  type: POST_ATTACK_LIST_EXECUTE_TAGGING_SUCCESS,
  payload: {
    tag: data.tag,
    taggedCount: data.tagged_count,
  }
});

const postAttackListExecuteTaggingFailure = (error) => ({
  type: POST_ATTACK_LIST_EXECUTE_TAGGING_FAILURE,
  payload: {
    error: error
  }
});

export function postAttackListExecuteTagging(data) {
  return async (dispatch) => {
    dispatch(postAttackListExecuteTaggingRequest());

    ExecutiveListApi.postAttackListExecuteTagging(data, dispatch)
      .then((response) => {
        dispatch(postAttackListExecuteTaggingSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postAttackListExecuteTaggingFailure(error.response ? error.response.data : error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/ExecutiveList.js